import OtpFlow from './OtpFlow';

export default {
  OtpFlow,
};
